// ** React Imports
import { lazy } from 'react';

const SettingsRoutes = [
  {
    path: 'settings',
    component: lazy(() => import('views/settings/settings')),
  },
  {
    path: 'settings/general',
    component: lazy(() => import('views/settings/general-settings')),
  },
  {
    path: 'settings/seo',
    component: lazy(() => import('views/settings/seo-settings')),
  },
  {
    // Terms & conditions and privacy policy (served at /rest/term, /rest/policy).
    path: 'settings/legal',
    component: lazy(() => import('views/legal-documents')),
  },
  {
    path: 'settings/google-reviews',
    component: lazy(() => import('views/settings/google-reviews')),
  },
  {
    path: 'settings/cashClear',
    component: lazy(() => import('views/cache')),
  },
  {
    path: 'settings/system-information',
    component: lazy(() => import('views/system-information')),
  },
  {
    path: 'settings/payments',
    component: lazy(() => import('views/payments')),
  },
  {
    path: 'settings/update',
    component: lazy(() => import('views/update')),
  },
  {
    path: 'settings/orderStatus',
    component: lazy(() => import('views/order-status')),
  },
];

export default SettingsRoutes;
